import Raven from 'raven-js';
import getLang from 'I18n/utils/getLang';
import { useFetchAllForUserLazyQuery } from '../../__generated__/chirp/com/hubspot/connected/application/status/rpc/frontend/ConnectedStatusGraphQLService.hooks';
export const useLazyGetAppStatuses = ({
  appId,
  categories,
  includeAllNamespaceStatuses = false
}) => {
  const [fetchStatuses, {
    data,
    loading,
    error,
    startPolling,
    stopPolling
  }] = useFetchAllForUserLazyQuery({
    variables: {
      locale: getLang(),
      statusFetchOptions: {
        appIds: [appId],
        categories,
        includeAllNamespaceStatuses
      }
    },
    onError: err => {
      Raven.captureException(err, {
        extra: {
          appId
        }
      });
    }
  });
  return {
    data: data === null || data === void 0 ? void 0 : data.results,
    loading,
    error,
    fetchStatuses,
    startPolling,
    stopPolling
  };
};